/**
 * 퀴즈 문제 풀기 동작 옵션
 *
 * @see docs/QUIZ_BEHAVIOR_OPTIONS.md
 */

export interface QuizBehaviorOptions {
    /** 순차 네비게이션: 푼 문제 + 현재 문제만 이동 가능 */
    sequentialNavigation: boolean

    /** 즉시 정오답 표시: false면 제출 완료만 표시 */
    showImmediateFeedback: boolean

    /** 다시 풀기 허용: true면 푼 문제 재시도 가능 (같은 세션 내) */
    allowRetry: boolean

    /** 통과 점수: 0이면 무조건 완료, 양수면 해당 % 이상 필요 */
    passScore: number
}

/**
 * 레슨 퀴즈 옵션
 * - 순차 진행, 즉시 피드백, 재시도 불가, 통과 조건 없음
 */
export const LESSON_QUIZ_OPTIONS: QuizBehaviorOptions = {
    sequentialNavigation: true,
    showImmediateFeedback: true,
    allowRetry: false,
    passScore: 0,
}

/**
 * 모듈 마무리 퀴즈 옵션
 * - 순차 진행, 피드백 없음, 재시도 가능, 70% 통과
 */
export const MODULE_QUIZ_OPTIONS: QuizBehaviorOptions = {
    sequentialNavigation: true,
    showImmediateFeedback: false,
    allowRetry: true,
    passScore: 70,
}

/**
 * AIQ 테스트 옵션
 * - 자유 이동, 피드백 없음, 재시도 가능, 통과 조건 없음
 */
export const AIQ_QUIZ_OPTIONS: QuizBehaviorOptions = {
    sequentialNavigation: false,
    showImmediateFeedback: false,
    allowRetry: true,
    passScore: 0,
}
